import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: '/share/',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld,
			meta:{
				title:'下载清理助手'
			}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js